import React from "react";

const FeedbackIcon = () => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1806_1505)">
        <path
          d="M13.0625 1.375C12.5155 1.375 11.9909 1.5923 11.6041 1.97909C11.2173 2.36589 11 2.89049 11 3.4375V6.1875C11.0001 6.61396 11.1323 7.02992 11.3786 7.37811C11.6248 7.7263 11.9729 7.9896 12.375 8.13175V9.625C12.375 9.75563 12.4123 9.88355 12.4824 9.99377C12.5526 10.104 12.6526 10.192 12.7709 10.2474C12.8892 10.3028 13.0209 10.3233 13.1504 10.3066C13.28 10.2899 13.4021 10.2366 13.5025 10.153L15.785 8.25H18.5625C19.1095 8.25 19.6341 8.0327 20.0209 7.64591C20.4077 7.25911 20.625 6.73451 20.625 6.1875V3.4375C20.625 2.89049 20.4077 2.36589 20.0209 1.97909C19.6341 1.5923 19.1095 1.375 18.5625 1.375H13.0625ZM12.375 3.4375C12.375 3.25516 12.4474 3.0803 12.5764 2.95136C12.7053 2.82243 12.8802 2.75 13.0625 2.75H18.5625C18.7448 2.75 18.9197 2.82243 19.0486 2.95136C19.1776 3.0803 19.25 3.25516 19.25 3.4375V6.1875C19.25 6.36984 19.1776 6.5447 19.0486 6.67364C18.9197 6.80257 18.7448 6.875 18.5625 6.875H15.5375C15.3767 6.87507 15.221 6.93151 15.0975 7.0345L13.75 8.1565V7.5625C13.75 7.38016 13.6776 7.2053 13.5486 7.07636C13.4197 6.94743 13.2448 6.875 13.0625 6.875C12.8802 6.875 12.7053 6.80257 12.5764 6.67364C12.4474 6.5447 12.375 6.36984 12.375 6.1875V3.4375ZM4.125 8.25C4.125 7.52065 4.41473 6.82118 4.93046 6.30546C5.44618 5.78973 6.14565 5.5 6.875 5.5C7.60435 5.5 8.30382 5.78973 8.81954 6.30546C9.33527 6.82118 9.625 7.52065 9.625 8.25C9.625 8.97935 9.33527 9.67882 8.81954 10.1945C8.30382 10.7103 7.60435 11 6.875 11C6.14565 11 5.44618 10.7103 4.93046 10.1945C4.41473 9.67882 4.125 8.97935 4.125 8.25ZM6.875 6.875C6.51033 6.875 6.16059 7.01987 5.90273 7.27773C5.64487 7.53559 5.5 7.88533 5.5 8.25C5.5 8.61467 5.64487 8.96441 5.90273 9.22227C6.16059 9.48013 6.51033 9.625 6.875 9.625C7.23967 9.625 7.58941 9.48013 7.84727 9.22227C8.10513 8.96441 8.25 8.61467 8.25 8.25C8.25 7.88533 8.10513 7.53559 7.84727 7.27773C7.58941 7.01987 7.23967 6.875 6.875 6.875ZM3.4375 12.375H10.3125C10.8595 12.375 11.3841 12.5923 11.7709 12.9791C12.1577 13.3659 12.375 13.8905 12.375 14.4375C12.375 15.972 11.7439 17.2013 10.7085 18.0331C9.68962 18.8512 8.32288 19.25 6.875 19.25C5.42712 19.25 4.06037 18.8512 3.0415 18.0331C2.0075 17.2013 1.375 15.972 1.375 14.4375C1.375 13.8905 1.5923 13.3659 1.97909 12.9791C2.36589 12.5923 2.89049 12.375 3.4375 12.375ZM10.3125 13.75H3.4375C3.25516 13.75 3.0803 13.8224 2.95136 13.9514C2.82243 14.0803 2.75 14.2552 2.75 14.4375C2.75 15.5609 3.19688 16.3941 3.90225 16.9606C4.6255 17.5409 5.665 17.875 6.875 17.875C8.085 17.875 9.1245 17.5409 9.84775 16.9606C10.5531 16.3941 11 15.5609 11 14.4375C11 14.2552 10.9276 14.0803 10.7986 13.9514C10.6697 13.8224 10.4948 13.75 10.3125 13.75Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1806_1505"
          x="0.375"
          y="0.375"
          width="21.25"
          height="19.875"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1806_1505"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1806_1505"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default FeedbackIcon;
